import { ChevronSmallLeftIcon as ChevronLeftBoldIcon } from "@wags/ui/product-icons.tsx";

/* eslint-disable react-doctor/no-multi-comp */
import { cn } from "../../lib/utils.ts";
import { iconButtonClass } from "./icon-button-class.ts";
import type { ComponentType } from "react";

export function MobileNavBackButton({
    onClick,
    className,
    ...props
}: { onClick: () => void } & Omit<
    React.ComponentProps<"button">,
    "type" | "children"
>) {
    return (
        <button
            type="button"
            aria-label="Back to previous page"
            data-slot="mobile-nav-back"
            className={cn(iconButtonClass, className)}
            onClick={onClick}
            {...props}
        >
            <ChevronLeftBoldIcon className="size-6" />
        </button>
    );
}

export function MobileNavAction({
    icon: Icon,
    onClick,
    label,
    className,
    ...props
}: {
    icon: ComponentType<{ className?: string }>;
    onClick: () => void;
    label: string;
} & Omit<React.ComponentProps<"button">, "type" | "children">) {
    return (
        <button
            type="button"
            aria-label={label}
            data-slot="mobile-nav-action"
            className={cn(iconButtonClass, className)}
            onClick={onClick}
            {...props}
        >
            <Icon className="size-6" />
        </button>
    );
}
